module.exports = __webpack_public_path__ + "media/images/mail/ico-twitter-10eb7340b320a12fa80bcda5c5cc1b8d.png";